module.exports = __webpack_public_path__ + "7a467ea58042f6f53d8eae82e53d0481.svg";